import styled from '@emotion/styled';
import { ContentBodyPadding, GNBSubMenuHeight, MaxContentBodySize } from 'constants/layout';
import { LineSubMenu } from 'ui-components/navigations/LineSubMenu';
import {
  ExploreNavigationMenu,
  ExploreNavigationMenuDisplayList,
  ExploreNavigationMenuPath,
  ExploreNavigationMenuText,
} from '@diritto/common/navigation/explore';
import { useMemo } from 'react';

export const ExploreNavigationBar = ({ selectedMenu }: { selectedMenu: ExploreNavigationMenu }) => {
  const path = useMemo(
    () => ({
      [ExploreNavigationMenu.All]: `/explore/${ExploreNavigationMenuPath[ExploreNavigationMenu.All]}`,
      [ExploreNavigationMenu.New]: `/explore/${ExploreNavigationMenuPath[ExploreNavigationMenu.New]}`,
      [ExploreNavigationMenu.UpcomingHidden]: `/explore/${
        ExploreNavigationMenuPath[ExploreNavigationMenu.UpcomingHidden]
      }`,
      [ExploreNavigationMenu.Exclusive]: `/explore/${ExploreNavigationMenuPath[ExploreNavigationMenu.Exclusive]}`,
      [ExploreNavigationMenu.CompletedOrPublished]: `/explore/${
        ExploreNavigationMenuPath[ExploreNavigationMenu.CompletedOrPublished]
      }`,
    }),
    [],
  );

  return (
    <StyledContainer>
      <StyledSubMenu
        menuList={ExploreNavigationMenuDisplayList}
        menuPath={path}
        menuText={ExploreNavigationMenuText}
        selectedMenu={selectedMenu}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  width: 100%;
  height: ${GNBSubMenuHeight}px;
  position: relative;
  display: flex;
  padding: 0 ${ContentBodyPadding}px;
  max-width: ${MaxContentBodySize}px;
`;

const StyledSubMenu = styled(LineSubMenu)``;
